export default __webpack_public_path__ + "static/media/Background_00238.020915ed.png";